import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AcademicYearService } from '../../../../../core/services/academic-year.service';
import { PeriodService } from '../../../../../core/services/period.service';
import { StopNoteService } from '../../../../../core/services/stop-note.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { FormsModule } from '@angular/forms';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { BrowserModule } from '@angular/platform-browser';
import { HeaderComponent } from '../../../layout/includes/header/header.component';

@Component({
    selector: 'app-stop-note',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxPaginationModule,],
    templateUrl: './stop-note.component.html',
    styleUrls: ['./stop-note.component.css']
})
export class StopNoteComponent {
  buttonsPermission :any|undefined;
  search_text=""
   ays:any[] =[]
   periods:any[] =[]
   roles:any[] =[]
   data:any[] =[]
   selected_data:any;
   modalOption:any; 
   isDtInitialized:boolean = false
   is_active:any
   loading=false
   tag="admin-stop-notes"
   pg={
     pageSize:10,
     p:0,
     total:0
   }
   role:any
   user:any
 
 
   constructor(
     private periodService:PeriodService,
     private ayService:AcademicYearService,
     private stopeNoteService:StopNoteService,
     private toastrService:ToastrService,
       config: NgbModalConfig,
       private lsService:LocalStorageService,
     private modalService: NgbModal) {
      config.backdrop = 'static';
      config.keyboard = false;
      }
 
 
   ngOnInit(): void {
     this.init()
 this.getActions()
   }
 
   init(){
     this.getAll()
      this.getPeriods()
      this.getAys()
   }
 
  
 
   getPeriods(){
     this.periodService.getByState(1).subscribe((res:any)=>{
       this.periods=res.data
     },
     (err:any)=>{
 AppErrorShow.showError("Gestion des périodes (Trimestres)",err)
     })
   }
 
   getAys(){
     this.ayService.getAll().subscribe((res:any)=>{
       this.ays=res.data
     },
     (err:any)=>{
 AppErrorShow.showError("Gestion des périodes (Trimestres)",err)
     })
   }
 
   getAll(){
     this.stopeNoteService.getAll().subscribe((res:any)=>{
       this.data=res.data
       this.pg.pageSize=10
       this.pg.p=0
       this.pg.total=res.data.length
       this.modalService.dismissAll()
     },
     (err:any)=>{
 AppErrorShow.showError("Gestion des périodes (Trimestres)",err)
     })
   }
 
 
   store(value:any){
     this.loading=true

     var d1 = new Date(value.alert_publication_date)
     var d2 = new Date(value.stop_date)
     if(d2 < d1){
      this.toastrService.error("La date d'arrêt de note doit ête postérieur à la pdate de publication du message d'alerte")
      return ;
     } 
     
     this.stopeNoteService.store(value).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getAll()
 
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion des périodes (Trimestres)",err)
 
     })
   }
   update(value:any){
     this.loading=true
 
     this.stopeNoteService.update(this.selected_data.id,value).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getAll()
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion des périodes (Trimestres)",err)
 
     })
   }
   delete(){
     if(!this.verifyIfElementChecked()) return ;
     let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
     confirmed.then((result:any)=>{
        if (result.isConfirmed) {
     this.stopeNoteService.delete(this.selected_data.id).subscribe((res:any)=>{
         this.toastrService.success(res.message)
         this.getAll()
     },
     (err:any)=>{
       console.log(err)
         AppErrorShow.showError("Gestion des périodes (Trimestres)",err)
 
     })
   }
 })
   }
   checked(el?:any){
     this.selected_data=el;
     this.is_active=el.is_active
   }
   verifyIfElementChecked(){
     console.log(this.selected_data)
     if (this.selected_data==null) {
       this.toastrService.warning("Aucun élément selectionné");
       return false;
     }
     return true;
   }
 
 
 
   dismiss(){
     this.modalService.dismissAll()
   }
 
   add(content:any){
     this.modalService.open(content,{size:'lg'});
   }
 
 
   show(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalOption={centered:false,size:"lg"}
     this.modalService.open(content,{size:'lg'});
   }
 
   edit(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalService.open(content,{size:'lg'});
 
   }
 
   setStatus(value:any){
 
     this.toastrService.warning("Opération en cours")
   
         this.stopeNoteService.setState(this.selected_data.id,value).subscribe((res:any)=>{
           this.toastrService.success(res.message)
           this.getAll()
       },
       (err:any)=>{
         console.log(err)
           AppErrorShow.showError("Gestion des périodes (Trimestres)",err)
 
       })
   }
 
   getPage(event:any){
     this.pg.p=event
   }
 
   getActions(){
     // this.buttonsPermission = {
     //   show:AppActionCheck.check(this.tag,'Consultation'),
     //   add:AppActionCheck.check(this.tag,'ajout'),
     //   edit:AppActionCheck.check(this.tag,'edition'),
     //   delete:AppActionCheck.check(this.tag,'suppression'),
     //   status:AppActionCheck.check(this.tag,'statut')
     // };
     this.buttonsPermission={
       show:false,
       add:true,
       edit:true,
       delete:true,
       status:true,
     }
   }
}
